// Polish translations
export const pl: Record<string, string> = {
  'app.name': 'VolleyBot',
  'app.loading': 'Ładowanie…',
  'app.youreAllSet': 'Wszystko gotowe!',
  'app.loadingHome': 'Ładowanie strony głównej…',

  'nav.home': 'Główna',
  'nav.games': 'Mecze',
  'nav.create': 'Utwórz',
  'nav.profile': 'Profil',
  'nav.admin': 'Admin',
  'nav.test': 'Test',
  'status.open': 'Otwarte',
  'status.full': 'Pełne',
  'status.going': 'W trakcie',
  'status.cancelled': 'Anulowane',
  'status.finished': 'Zakończone',

  'welcome.title': 'Witamy w VolleyBot',
  'welcome.subtitle': 'Wybierz swój poziom gry, aby zacząć.',
  'welcome.cta': 'Dalej',
  'welcome.done.title': 'Wszystko gotowe!',
  'welcome.done.subtitle': 'Ładowanie strony głównej…',
  'welcome.hello': 'Cześć, {name}!',
  'welcome.intro':
    'VolleyBot pomaga znajdować i organizować mecze siatkówki w Twoim mieście. Skonfigurujemy Twój profil w 30 sekund.',
  'welcome.feature.findGames.title': 'Znajdź mecze w pobliżu',
  'welcome.feature.findGames.desc': 'Otwarte mecze w Twoim mieście, filtrowane według poziomu gry.',
  'welcome.feature.join.title': 'Dołącz jednym kliknięciem',
  'welcome.feature.join.desc': 'Widzisz, kto gra, dzielisz koszt kortu, dostajesz przypomnienia.',
  'welcome.feature.organize.title': 'Zorganizuj własny mecz',
  'welcome.feature.organize.desc': 'Wybierz miejsce, czas i poziom — zaproś graczy w sekundy.',
  'welcome.getStarted': 'Zaczynamy',
  'welcome.footNote': 'Zawsze możesz to zmienić w Profilu.',
  'welcome.skill.title': 'Jaki jest Twój poziom gry?',
  'welcome.skill.subtitle':
    'Wybierz poziom, który najlepiej opisuje Twoją grę. Dobierzemy Ci mecze o podobnym poziomie.',
  'welcome.skill.cta': 'Dalej',
  'welcome.skill.saving': 'Zapisywanie…',

  'skill.LEVEL_1': 'Początkujący',
  'skill.LEVEL_2': 'Początkujący (Amator)',
  'skill.LEVEL_3': 'Średniozaawansowany',
  'skill.LEVEL_4': 'Zaawansowany',
  'skill.LEVEL_5': 'Półpro',
  'skill.LEVEL_6': 'Profesjonalny',
  'skill.LEVEL_1.desc':
    'Zna zasady, ale podstawowe elementy (przyjęcie, zagrywka, wystawa) są niestabilne.',
  'skill.LEVEL_2.desc': 'Górna zagrywka, pozycyjna obrona, proste przyjęcie.',
  'skill.LEVEL_3.desc': 'Stabilne przyjęcie, pewne ataki, pierwsze próby zbiorowego bloku.',
  'skill.LEVEL_4.desc':
    'Pewna gra z rozgrywającym, ataki w pierwszym tempie, mocne i taktyczne zagrywki.',
  'skill.LEVEL_5.desc':
    'Głębokie rozumienie taktyki, mocne zagrywki, wyćwiczone kombinacje.',
  'skill.LEVEL_6.desc':
    'Byli zawodowcy, mistrzowie sportu, doskonała technika, błyskawiczna praca zespołowa.',
  'skill.wheelchair': 'Zawodnik na wózku',

  'home.title': 'Główna',
  'home.hello': 'Cześć, {name}!',
  'home.botAlerts': 'Powiadomienia o meczach na czacie bota',
  'home.botAlertsSub': 'Zezwól na wiadomości, żeby zmiany meczu trafiały na ten czat.',
  'home.upcomingGames': 'Nadchodzące mecze',
  'home.seeAll': 'Zobacz wszystkie',
  'home.noGames': 'Brak nadchodzących meczów',
  'home.findGame': 'Znajdź mecz',
  'home.createGame': 'Utwórz mecz',
  'home.createGameSub': 'Zaproś graczy w kilka sekund',
  'home.pickYourLevel': 'Wybierz swój poziom gry',
  'home.pickYourLevelSub': 'Powiedz innym graczom, jak mocno grasz, aby mogli dobrać Cię do drużyny.',
  'home.openGames': 'Otwarte mecze',
  'home.freeSpots': 'Wolne miejsca',
  'home.allGames': 'Wszystkie mecze',
  'home.openGamesInCity': '{count} otwartych meczów w Twoim mieście.',
  'home.noGamesSub': 'Nie ma jeszcze meczów - zorganizuj pierwszy.',
  'home.emptyCta': 'Zorganizuj pierwszy mecz siatkówki w {city}. Kliknij "Utwórz mecz", aby zacząć.',

  'profile.title': 'Profil',
  'profile.about': 'O Tobie',
  'profile.age': 'Wiek',
  'profile.city': 'Miasto',
  'profile.language': 'Język',
  'profile.bio': 'Krótko o sobie (opcjonalne)',
  'profile.skill': 'Poziom gry',
  'profile.skillFromEvaluations': 'Na podstawie {n} ocen',
  'profile.save': 'Zapisz',
  'profile.saved': 'Profil zapisany',
  'profile.signOut': 'Wyloguj',
  'profile.signOutConfirm': 'Wylogować z VolleyBot?',
  'profile.adminPanel': 'Panel admina',
  'profile.blacklist': 'Zablokowani gracze',
  'profile.invitations': 'Zaproszenia',
  'profile.payments': 'Płatności',
  'profile.status.admin': 'Admin',

  'games.title': 'Mecze',
  'games.filter.city': 'Miasto',
  'games.filter.skill': 'Poziom',
  'games.filter.skillAny': 'Dowolny poziom',
  'games.filter.bucket.beginner': 'Początkujący',
  'games.filter.bucket.intermediate': 'Średniozaawansowany',
  'games.filter.bucket.advanced': 'Zaawansowany',
  'games.filter.dateFrom': 'Od',
  'games.filter.dateTo': 'Do',
  'games.filter.spots': 'Miejsc',
  'games.filter.any': 'Dowolnie',
  'games.filter.search': 'Szukaj w notatkach',
  'games.filter.apply': 'Zastosuj',
  'games.filter.clear': 'Wyczyść',
  'games.filter.quick.all': 'Wszystkie',
  'games.filter.quick.open': 'Otwarte',
  'games.filter.quick.today': 'Dziś',
  'games.filter.quick.free': 'Darmowe',
  'games.filter.quick.indoor': 'Hala',
  'profile.editProfile': 'Edytuj profil',
  'profile.doneEditing': 'Gotowe',
  'profile.activity': 'Aktywność',
  'profile.gamesHosted': 'Utworzone gry',
  'profile.gamesJoined': 'Dołączone gry',
  'games.empty': 'Brak meczów spełniających filtry.',

  'game.spots': '{count} / {total} miejsc',
  'game.spotsFull': 'Pełne',
  'game.waitlistNotify': 'Powiadom mnie',
  'game.waitlistSubscribed': 'Obserwuję',
  'game.waitlistStop': 'Stop',
  'game.waitlistHint': 'Wyślemy wiadomość na Telegram, gdy ktoś wyjdzie.',
  'game.waitlistToast': 'OK — napiszemy na Telegram, gdy zwolni się miejsce.',
  'game.waitlistToastOff': 'Przestaliśmy obserwować ten mecz.',
  'game.changeTime': 'Zmień godzinę',
  'game.changeTimeTitle': 'Przełóż mecz',
  'game.changeTimeHint': 'Gracze w składzie dostaną alert na Telegram z nową godziną.',
  'game.changeTimeSave': 'Zapisz nową godzinę',
  'game.changeTimeCurrent': 'Teraz: {when}',
  'game.changeTimeInvalid': 'Wybierz godzinę w przyszłości.',
  'game.changeTimeSame': 'To ta sama godzina — nic do zmiany.',
  'game.changeTimeDone': 'Godzina zaktualizowana. Gracze zostali powiadomieni.',
  'game.edit': 'Edytuj grę',
  'game.editTitle': 'Edytuj grę',
  'game.editHint': 'Zmień miejsce, typ, godzinę, poziom, miejsca albo cenę. Wszyscy zapisani dostaną wiadomość na Telegramie, jeśli choć raz otworzyli bota.',
  'game.editPriceHint': '0 zostawia mecz za darmo. Większa kwota dzieli się na miejsca.',
  'game.editPriceInvalid': 'Podaj cenę albo 0, żeby mecz został darmowy.',
  'game.editSave': 'Zapisz',
  'game.editDone': 'Gra zaktualizowana.',
  'game.editNoChanges': 'Nic nie zmieniono.',
  'game.editAddressRequired': 'Adres jest wymagany.',
  'game.editSpotsMin': 'Minimum 2 miejsca.',
  'game.editSpotsBelowRoster': 'Nie mniej niż obecni gracze ({n}).',
  'game.spotsOneLeft': 'Zostało 1 miejsce',
  'game.spotsLeft': 'Pozostało {n} miejsc',
  'game.perPlayer': '{amount} / gracz',
  'game.closed': 'Zamknięte lobby',
  'game.closedHint': 'Tylko z zaproszeniem — wyślij prośbę i organizator zaakceptuje.',
  'game.hidePlayers': 'Ukryj graczy przed osobami spoza gry',
  'game.hidePlayersHint': 'Osoby spoza gry widzą skład jako Incognito. Uczestnicy widzą wszystkich.',
  'game.playersHiddenBanner': 'Lista graczy jest ukryta, dopóki nie dołączysz.',
  'game.playersHiddenHint': 'Dołącz, aby zobaczyć skład',
  'create.field.hidePlayers': 'Ukryj graczy przed osobami spoza gry',
  'game.paid': 'Płatny mecz',
  'game.free': 'Bezpłatny mecz',
  'game.host': 'Organizator',
  'game.perPlayerShort': '/ gracz',
  'game.playersShort': 'graczy',
  'game.playersMore': 'więcej: {count}',
  'game.spotsLeftShort': '{count} wolnych',
  'game.playType.indoor': 'W hali',
  'game.playType.outdoor': 'Na zewnątrz',
  'game.playType.beach': 'Na plaży',
  'game.join': 'Dołącz',
  'game.leave': 'Opuść',
  'game.cancel': 'Anuluj mecz',
  'game.finish': 'Zakończ mecz',
  'game.requestToJoin': 'Wyślij prośbę',
  'game.requestPending': 'Prośba wysłana',
  'game.joinRequests': 'Prośby o dołączenie ({n})',
  'game.approveRequest': 'Zaakceptuj',
  'game.rejectRequest': 'Odrzuć',
  'game.finishConfirm': 'Oznaczyć mecz jako zakończony?',
  'game.cancelConfirm': 'Anulować ten mecz?',
  'game.evaluations': 'Oceń graczy',
  'game.managePayments': 'Płatności',
  'game.invitePlayers': 'Zaproś graczy',
  'game.share': 'Udostępnij',
  'game.shareHeadline': 'Otwarta gra — kto gra?',
  'game.shareCta': 'Otwórz i dołącz:',
  'game.shareSpots': '{filled}/{total} graczy · {left} wolnych',
  'game.shareSpotsFull': '{filled}/{total} graczy · brak miejsc',
  'game.shareFree': 'Za darmo',
  'game.shareSkill': 'Poziom {n}',
  'game.shareUnavailable': 'Udostępnianie niedostępne — spróbuj za chwilę.',
  'game.reserve': 'Zarezerwuj miejsce',
  'game.reserveHint': 'Trzyma miejsce dla kogoś, kto nie może dołączyć teraz. Inni widzą tylko „Incognito”.',
  'game.reserveNote': 'Prywatna notatka',
  'game.reserveNotePlaceholder': 'Dla kogo? (widzisz tylko ty)',
  'game.reserveRemove': 'Zwolnij',
  'game.reservedSpots': 'Zarezerwowane ({n})',
  'game.incognito': 'Incognito',
  'game.incognitoHint': 'Miejsce zajęte — jeszcze nie w aplikacji',

  'gameDetail.players': 'Gracze',
  'gameDetail.noPlayers': 'Brak graczy',
  'gameDetail.address': 'Adres',
  'gameDetail.startsAt': 'Początek',
  'gameDetail.notes': 'Notatki',
  'gameDetail.cover': 'Zdjęcie obiektu',
  'gameDetail.roleOrganizer': 'Organizator',
  'gameDetail.rolePlayer': 'Gracz',
  'gameDetail.tagHost': 'ORG',
  'gameDetail.tagYou': 'TY',
  'gameDetail.reportAction': 'Zgłoś',
  'gameDetail.actionsFor': 'Akcje dla {name}',
  'gameDetail.tabPlayers': 'Gracze',
  'gameDetail.tabInfo': 'Info',
  'gameDetail.joined': 'Dołączył',
  'gameDetail.confirmedPlayers': 'Potwierdzeni gracze ({n})',
  'gameDetail.pricePerPlayer': 'Za gracza',

  'create.title': 'Nowy mecz',
  'create.subtitle': 'Wypełnij szczegóły i zaproś graczy',
  'create.field.playType': 'Gdzie będzie mecz',
  'create.playType.indoor': 'W hali',
  'create.playType.outdoor': 'Na zewnątrz',
  'create.playType.beach': 'Na plaży',
  'create.section.where': 'Gdzie',
  'create.section.when': 'Kiedy',
  'create.section.who': 'Kto',
  'create.section.cost': 'Koszt',
  'create.section.notes': 'Notatki',
  'create.section.covers': 'Zdjęcie boiska',
  'game.coversTitle': 'Zdjęcie boiska',
  'game.coversHint': 'Opcjonalnie — jedno zdjęcie kortu. JPEG/PNG/WebP, do 2 MB. Zapisujemy je w profilu na kolejną grę.',
  'game.coversAdd': 'Dodaj zdjęcie',
  'game.coversClear': 'Usuń własne zdjęcie',
  'game.coversReuseHint': 'Używamy zapisanego zdjęcia kortu — stuknij, by zamienić, albo utwórz grę bez zmian.',
  'gameDetail.activityTitle': 'Aktywność graczy',
  'gameDetail.notifyCount': '{n} nacisnęło Powiadom mnie',
  'gameDetail.activityEmpty': 'Brak wejść/wyjść.',
  'gameDetail.activityJoined': '„{name}” dołączył do gry · {when}',
  'gameDetail.activityLeft': '„{name}” opuścił grę · {when}',
  'create.field.venue': 'Obiekt',
  'create.field.savedPlaces': 'Zapisane miejsca',
  'create.field.savedPlacesPlaceholder': 'Wybierz zapisane miejsce…',
  'create.field.noSavedPlaces': 'Nie ma jeszcze zapisanych miejsc. Adres zapisze się po utworzeniu meczu.',
  'create.field.placeName': 'Nazwa miejsca',
  'create.field.placeNamePlaceholder': 'np. Boisko w parku lub sala szkolna',
  'create.field.venueAddress': 'Adres',
  'create.field.venueAddressPlaceholder': 'np. ul. Piekary 17, Poznań',
  'create.field.selectVenue': '— wybierz obiekt —',
  'create.field.start': 'Początek',
  'create.field.duration': 'Godzin',
  'create.field.skill': 'Poziom gry',
  'create.field.spots': 'Wszystkich miejsc',
  'create.field.unlimited': 'Bez limitu',
  'create.field.totalCost': 'Łączny koszt kortu',
  'create.field.currency': 'Waluta',
  'create.field.addressHint': 'Adres / miejsce spotkania',
  'create.field.addressHintPlaceholder': 'np. boczne wejście, park za galerią',
  'create.field.coverPreview': 'Okładka',
  'create.field.coverPreviewHint': 'Automatycznie dobierana do typu gry.',
  'create.field.paid': 'To jest płatny mecz',
  'create.paidStatus.on': 'Płatny mecz — gracze będą musieli zapłacić swoją część.',
  'create.paidStatus.off': 'Darmowy mecz — zostaw koszt 0, aby był darmowy.',
  'create.field.noVenues': 'Brak obiektów w Twoim mieście. Dodaj jeden z zakładki Gry.',
  'create.field.closed': 'Zamknięte lobby (tylko zaproszenia)',
  'create.cta': 'Utwórz mecz',
  'create.cta.creating': 'Tworzenie…',
  'create.cost.auto': 'Auto: {venue} × {hours}h.',
  'create.cost.custom': 'Wprowadzono własną kwotę.',
  'create.cost.empty': 'Wybierz obiekt, aby uzupełnić automatycznie.',
  'create.cost.manual': 'Zapisane miejsca z ceną uzupełnią koszt automatycznie. W innym przypadku wpisz go ręcznie.',
  'create.perPlayer': 'Za gracza: {amount}',
  'create.splitBetween': 'Podzielone na {n} graczy',
  'create.unlimitedHint': 'Bez górnego limitu graczy',
  'create.venueMax': 'Max na obiekcie: {n} graczy',

  'blacklist.title': 'Zablokowani gracze',
  'blacklist.empty': 'Nikogo nie zablokowałeś.',
  'blacklist.add': 'Zablokuj gracza',
  'blacklist.reason': 'Powód (opcjonalnie)',
  'blacklist.remove': 'Odblokuj',
  'blacklist.maxed': 'Możesz zablokować do 10 osób. Najpierw kogoś odblokuj.',
  'blacklist.warning.title': 'W meczu jest zablokowany gracz',
  'blacklist.warning.body': 'Zablokowałeś {name}. Czy na pewno chcesz dołączyć?',
  'blacklist.warning.confirm': 'Dołącz mimo to',
  'blacklist.warning.cancel': 'Anuluj',

  'report.title': 'Zgłoś gracza',
  'report.reason.toxic': 'Toksyczne zachowanie',
  'report.reason.skipped': 'Nie przyszedł na mecz',
  'report.reason.harassment': 'Nękanie',
  'report.reason.cheating': 'Oszustwo',
  'report.reason.other': 'Inne',
  'report.details': 'Szczegóły (opcjonalne)',
  'report.submit': 'Wyślij zgłoszenie',
  'report.thanks': 'Dziękujemy — administratorzy rozpatrzą zgłoszenie.',

  'eval.title': 'Oceń graczy',
  'eval.subtitle': 'Oceń kogo chcesz — «Pomiń» przy imieniu albo wyślij tylko wybrane oceny.',
  'eval.alreadyRated': 'Już oceniony',
  'eval.skip': 'Pomiń',
  'eval.skipAll': 'Pomiń wszystkich',
  'eval.skipPlayer': 'Pomiń',
  'eval.skipped': 'Pominięty',
  'eval.undoSkip': 'Oceń',
  'eval.done': 'Gotowe',
  'eval.levelN': 'Poz. {n}',
  'eval.noPlayers': 'Brak współgraczy do oceny.',
  'eval.submit': 'Wyślij oceny',
  'eval.thanks': 'Dziękujemy — Twoje oceny zostały zapisane.',

  'invite.title': 'Zaproszenia',
  'invite.empty': 'Brak oczekujących zaproszeń.',
  'invite.emptySearch': 'Brak graczy — spróbuj imienia lub @username.',
  'invite.accept': 'Akceptuj',
  'invite.decline': 'Odrzuć',
  'invite.ignore': 'Ignoruj',
  'invite.invitePlayer': 'Zaproś gracza',
  'invite.invited': 'Zaproszenie wysłane',
  'invite.invitedTo': 'Zaproszenie wysłane do {name}',
  'invite.inviteFailed': 'Nie udało się zaprosić {name}',
  'invite.bannerTitle': 'Masz nowe zaproszenie do gry',
  'invite.openGame': 'Otwórz grę',
  'invite.searchPlaceholder': 'Szukaj po imieniu lub @username',
  'invite.noResults': 'Brak graczy spełniających kryteria',
  'invite.inviteAction': 'Zaproś {name}',
  'invite.notifyAria': '{count} oczekujących zaproszeń',
  'invite.sentTitle': 'Wysłane',
  'invite.statusSent': 'Wysłano',
  'invite.statusRead': 'Przeczytano',
  'invite.statusAccepted': 'Zaakceptowano',
  'invite.statusDeclined': 'Odrzucono',
  'invite.statusIgnored': 'Zignorowano',
  'invite.statusInactive': 'Nieaktywne',
  'invite.resend': 'Ponów',
  'invite.resendAria': 'Wyślij zaproszenie ponownie: {name}',
  'invite.resentTo': 'Zaproszenie wysłane ponownie: {name}',

  'payments.title': 'Płatności',
  'payments.totalCost': 'Łączny koszt',
  'payments.perPlayer': 'Za gracza',
  'payments.collected': 'Zebrane',
  'payments.cashCollected': 'Zebrane gotówką',
  'payments.methodHint': 'Dotknij $ (gotówka) lub kartę (przelew). Tylko jedno. Ponowne dotknięcie czyści (niezapłacone).',
  'payments.cashHint': 'Dotknij przycisku gotówki, gdy gracz zapłaci Ci gotówką na boisku.',
  'payments.players': 'Gracze',
  'payments.status': 'Status',
  'payments.paid': 'Zapłacone',
  'payments.paidCash': 'Gotówka',
  'payments.paidBank': 'Bank',
  'payments.unpaid': 'Niezapłacone',
  'payments.markPaid': 'Oznacz jako zapłacone',
  'payments.markPaidCash': 'Oznacz jako zapłacone gotówką',
  'payments.markPaidBank': 'Oznacz jako zapłacone przelewem',
  'payments.markUnpaid': 'Oznacz jako niezapłacone',
  'payments.myUnpaid': 'Jesteś winien {amount} za {venue}',

  'calendar.title': 'Kalendarz',
  'calendar.today': 'Dzisiaj',
  'calendar.upcoming': 'Nadchodzące',
  'calendar.past': 'Przeszłe',

  'lang.title': 'Język',
  'lang.uk': 'Українська',
  'lang.pl': 'Polski',
  'lang.en': 'English',
  'lang.ru': 'Москальска',

  'auth.banned.title': 'Zostałeś zablokowany',
  'auth.banned.body': 'Powód: {reason}',
  'auth.banned.contact': 'Skontaktuj się z pomocą, jeśli uważasz, że to pomyłka.',

  'common.cancel': 'Anuluj',
  'common.save': 'Zapisz',
  'common.delete': 'Usuń',
  'common.confirm': 'Potwierdź',
  'common.search': 'Szukaj',
  'common.loading': 'Ładowanie…',
  'common.retry': 'Ponów',
  'common.error': 'Coś poszło nie tak',
  'common.close': 'Zamknij',
  'common.back': 'Wstecz',
  'common.optional': 'Opcjonalne',
  'common.you': 'Ty',

  'userProfile.view': 'Zobacz profil',
  'userProfile.viewNamed': 'Profil gracza {name}',
  'userProfile.openTelegram': 'Otwórz w Telegramie',
  'userProfile.message': 'Napisz w Telegramie',
  'userProfile.block': 'Zablokuj gracza',
  'userProfile.blockConfirm': 'Zablokować {name}? Nie będzie pojawiać się w Twoich podpowiedziach.',
  'userProfile.notFound': 'Nie znaleziono gracza',
  'userProfile.notFoundText': 'Ten profil został usunięty lub jest niedostępny.',

  'banner.signOut': 'Wylogowano.',
  'banner.saved': 'Zapisano.',
  'banner.deleted': 'Usunięto.',

  'admin.title': 'Panel admina',
  'admin.subtitle': 'Zarządzaj użytkownikami, meczami, zgłoszeniami i zapisanymi miejscami.',
  'admin.subtitleSection': 'Admin · {section}',
  'admin.users': 'Użytkownicy',
  'admin.activity': 'Użycie aplikacji',
  'admin.games': 'Mecze',
  'admin.venues': 'Obiekty',
  'admin.reports': 'Zgłoszenia',
  'admin.ratings': 'Oceny wystawione',
  'admin.fb': 'FB',
  'admin.audit': 'Audyt',
  'admin.heatmap': 'Mapa ciepła',
  'admin.stats': 'Statystyki',
  'admin.search': 'Szukaj…',
  'admin.ban': 'Zablokuj',
  'admin.unban': 'Odblokuj',
  'admin.banReason': 'Powód blokady',
  'admin.userDetails': 'Szczegóły użytkownika',
  'admin.userSkill': 'Poziom umiejętności',
  'admin.userSkillHint': 'Ustaw wynik na odznace. Blokada chroni go przed ocenami graczy.',
  'admin.userSkillSave': 'Zapisz wynik',
  'admin.userSkillSaved': 'Wynik zapisany.',
  'admin.userSkillClear': 'Wyczyść wynik',
  'admin.userSkillLock': 'Zablokuj przed ocenami graczy',
  'admin.userWheelchair': 'Pokaż ikonę wózka zamiast liczby',
  'admin.userActivity': 'Aktywność',
  'admin.appUsage': 'Użycie aplikacji',
  'admin.stat.visited': 'Odwiedzone',
  'admin.stat.cancelled': 'Anulowane',
  'admin.stat.created': 'Utworzone',
  'admin.stat.sessionsPerWeek': 'Sesji / tydz.',
  'admin.stat.entriesDay': 'Wejść / dzień',
  'admin.stat.entriesWeek': 'Wejść / tydzień',
  'admin.stat.entriesMonth': 'Wejść / miesiąc',
  'admin.stat.avgTimeInApp': 'Śr. czas w aplikacji',
  'admin.stat.lastActive': 'Ostatnia aktywność',
  'admin.stat.evalGiven': 'Wystawione oceny',
  'admin.stat.evalReceived': 'Otrzymane oceny',
  'admin.stat.reportsAgainst': 'Zgłoszenia przeciw',
  'admin.stat.paymentsMade': 'Dokonane płatności',
  'admin.stat.evaluatedSkill': 'Oceniony poziom',
  'admin.bannedWithReason': 'Zablokowany: {reason}',
  'admin.roleAdmin': 'Admin',
  'admin.badgeBanned': 'Zablokowany',
  'admin.filterBanned': 'Zablokowani',
  'admin.filterActive': 'Aktywni',
  'admin.deleteUser': 'Usuń użytkownika',
  'admin.deleteUserConfirm': 'Usunąć użytkownika {name}? Tej operacji nie można cofnąć.',
  'admin.cancelGame': 'Anuluj mecz',
  'admin.resolve': 'Oznacz jako rozpatrzone',
  'admin.dismiss': 'Odrzuć',
  'admin.resolveAndBan': 'Rozpatrz + ban',
  'admin.index.stats': 'Użytkownicy, mecze, miejsca i rejestracje',
  'admin.index.users': 'Zarządzaj rolami, banami i aktywnością',
  'admin.index.activity': 'Wejścia i czas w aplikacji dla każdego użytkownika',
  'admin.index.games': 'Anuluj, zakończ lub sprawdź dowolny mecz',
  'admin.index.venues': 'Przeglądaj zapisane miejsca używane w meczach',
  'admin.index.reports': 'Przeglądaj i rozwiązuj zgłoszenia',
  'admin.index.ratings': 'Dokładne oceny, które gracz wystawił innym',
  'admin.ratingsSearch': 'Szukaj gracza…',
  'admin.ratingsPick': 'Wyszukaj gracza, żeby zobaczyć oceny, które wystawił.',
  'admin.ratingsFrom': 'Oceny wystawione przez tego gracza',
  'admin.ratingsEmpty': 'Ten gracz nikogo jeszcze nie ocenił.',
  'admin.ratingsCount': '{n} ocen',
  'admin.index.fb': 'Siatkarskie ogłoszenia z grupy na Facebooku z tego tygodnia',
  'admin.fbHint': 'Wklej posty z tego tygodnia. Kilka postów rozdziel linią, na której jest tylko ---. Komplet, Komplekt albo Full znaczy, że gra jest pełna. „przy komplecie” to cena, nie pełna gra.',
  'admin.fbGroup': 'Otwórz grupę na Facebooku',
  'admin.fbPaste': 'Treść posta',
  'admin.fbLink': 'Link (opcjonalnie)',
  'admin.fbAdd': 'Dodaj na tablicę',
  'admin.fbEmpty': 'Brak ogłoszeń z tego tygodnia.',
  'admin.fbStatus': 'Status',
  'admin.fbDate': 'Data',
  'admin.fbLevel': 'Poziom gry',
  'admin.fbPlaces': 'Wolne miejsca',
  'admin.fbAddress': 'Adres',
  'admin.fbPostLink': 'Link',
  'admin.fbOpen': 'Wolne',
  'admin.fbFull': 'Komplet',
  'admin.fbDelete': 'Usuń',
  'admin.fbRaw': 'Oryginalny post',
  'admin.fbAdded': 'Dodano {n}',
  'admin.fbMissing': '—',
  'admin.activityEmpty': 'Brak użytkowników pasujących do wyszukiwania.',
  'admin.activityShowing': 'Pokazano {shown} z {total}',
  'admin.stat.entriesDayShort': 'Dzień',
  'admin.stat.entriesWeekShort': 'Tydzień',
  'admin.stat.entriesMonthShort': 'Miesiąc',
  'admin.stat.avgTimeShort': 'Śr. czas',
  'admin.stat.neverActive': 'Nigdy nie otworzył aplikacji',
  'admin.stat.activeJustNow': 'Aktywny przed chwilą',
  'admin.stat.activeMinutesAgo': 'Aktywny {n} min temu',
  'admin.stat.activeHoursAgo': 'Aktywny {n} godz. temu',
  'admin.stat.dau': 'DAU',
  'admin.stat.wau': 'WAU',
  'admin.stat.mau': 'MAU',
  'admin.stat.sessionsToday': 'Sesje dziś',
  'admin.stat.avgSession': 'Śr. sesja',
  'admin.stat.signups24h': 'Rejestracje (24h)',
  'admin.stat.finishedGames': 'Zakończone mecze',
  'admin.stat.topScreens': 'Top ekranów (7d)',
  'admin.stat.topActions': 'Top działań (7d)',
  'admin.stat.topClicks': 'Top kliknięć (7d)',
  'admin.stat.platforms': 'Platformy (7d)',
  'admin.stat.languages': 'Języki (7d)',
  'admin.stat.rankEmpty': 'Brak danych — korzystaj z aplikacji.',
  'admin.index.heatmap': 'Gdzie użytkownicy klikają na ekranach',
  'admin.heatmapFilter': 'Filtruj po ścieżce ekranu…',
  'admin.heatmapEmpty': 'Brak danych o kliknięciach.',
  'admin.heatmapAvgPos': 'śr. tap ({x}, {y})',
  'venue.indoor': 'Hala',
  'venue.outdoor': 'Na zewnątrz',

  'error.network': 'Błąd sieci. Spróbuj ponownie.',
  'error.unauthorized': 'Zaloguj się ponownie.',
  'error.forbidden': 'Nie masz uprawnień.',
  'error.notFound': 'Nie znaleziono.',
  'error.tooLarge': 'Plik jest za duży.',
  'error.unknown': 'Coś poszło nie tak.',

  'empty.notSignedIn': 'Nie jesteś zalogowany',
  'empty.notSignedInText': 'Otwórz tę aplikację z Telegrama, aby skonfigurować profil.',

  'onboarding.chooseLevel': 'Wybierz swój poziom',
  'onboarding.levelPrompt': 'Wybierz poziom, który najlepiej Cię opisuje. Inni gracze używają tego do dobierania meczów.',

  'city.default': 'Domyślne miasto',

  'msg.profileUpdated': 'Profil zaktualizowany',
  'msg.gameCreated': 'Mecz utworzony',
  'msg.gameCancelled': 'Mecz anulowany',
  'msg.gameLeft': 'Opuszczono mecz',
  'msg.gameJoined': 'Dołączono do meczu',
  'msg.blacklistAdded': 'Gracz zablokowany',
  'msg.blacklistRemoved': 'Gracz odblokowany',
  'msg.reportSubmitted': 'Zgłoszenie wysłane',
  'msg.evaluationsSubmitted': 'Oceny zapisane',
  'msg.invitationResponded': 'Zaproszenie zaktualizowane',
  'msg.paymentUpdated': 'Płatność zaktualizowana',
  'msg.languageUpdated': 'Język zaktualizowany',
  'msg.locationUpdated': 'Lokalizacja zaktualizowana',
  'msg.signOutDone': 'Wylogowano',

  // ===== Weighted skill level feature =====
  'welcome.changeMode.title': 'Zmień swój poziom gry',
  'welcome.changeMode.subtitle':
    'Wybierz poziom, który najlepiej opisuje jak teraz grasz. Wpłynie to na rekomendacje meczów.',
  'welcome.changeMode.cta': 'Zapisz poziom',
  'welcome.changeMode.successTitle': 'Poziom zaktualizowany',
  'welcome.changeMode.successSub':
    'Twój nowy poziom został zapisany. Zostanie zastosowany do przyszłych meczów.',
  'home.tapToChangeLevel': 'Kliknij, aby zmienić swój poziom gry',
  'home.ratePlayers': 'Oceń graczy',
  'home.ratePlayersSub': 'Pomóż skorygować poziomy po ostatniej grze',
  'profile.tapToChangeLevel': 'Kliknij, aby zmienić swój poziom gry',
  'eval.looksRight': 'Zgadza się · Poziom {n}',
  'eval.suggestDifferent': 'Zaproponuj inny poziom',
};
